import apiService from './apiService'

/**
 * Settings Service
 * Handles API calls for application settings including AWS credentials
 */
export default {
  /**
   * Get application settings from the API
   * @returns {Promise} Promise that resolves to settings data
   */
  async getSettings() {
    try {
      const response = await apiService.get('settings')
      return response.data
    } catch (error) {
      console.error('Error fetching settings:', error)
      throw error
    }
  },

  /**
   * Get AWS configuration from settings
   * @returns {Promise} Promise that resolves to AWS config
   */
  async getAwsConfig() {
    try {
      const settings = await this.getSettings()
      console.log('Settings response:', settings)
      if (settings.success && settings.data && settings.data.aws) {
        console.log('AWS config found:', settings.data.aws)
        return settings.data.aws
      }
      console.error('AWS configuration not found in settings. Settings structure:', settings)
      throw new Error('AWS configuration not found in settings')
    } catch (error) {
      console.error('Error fetching AWS config:', error)
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/settingsService.js